import {Component, OnInit} from '@angular/core';
import {ImSchemaBaseComponent} from "../im-schema-base.component";


@Component({
    selector: 'im-schema-side',
    templateUrl: 'im-schema-side.component.html',
    standalone: false
})
export class ImSchemaSideComponent extends ImSchemaBaseComponent implements OnInit {


    ngOnInit(): void {
        super.ngOnInit();
    }

}
